// Redux action types for the in-place retry of a failed promotion.
//
// Maps to ``POST /deployments/<promotion_id>/retry`` -- the
// BE re-runs the same background deployment flow on the existing
// promotion record (no new uid, no FE navigation needed).
const action = "PROMOTION_RETRY";

export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

export const retryRequest = (payload) => ({
  type: REQUEST,
  payload,
});

export const retrySuccess = (response) => ({
  type: RESPONSE,
  payload: response,
});

export const retryFailure = (error) => ({
  type: FAILURE,
  payload: error,
});

export const clearState = () => ({
  type: CLEAR,
});
